export enum CustomTooltipActionType {
    SET_STATE_CUSTOM_TOOLTIP = 'SET_STATE_CUSTOM_TOOLTIP',
    CLOSE_CUSTOM_TOOLTIP = 'CLOSE_CUSTOM_TOOLTIP'
}

export interface  CustomTooltipState {
    customTooltipState: {
        status: 'error' | 'success'| 'notice',
        titleText: string,
        text: string
    } | null
}

export interface CustomTooltipAction {
    type: string,
    payload: {
        status: 'error' | 'success'| 'notice',
        titleText: string,
        text: string
    } | null
}